import type { FC } from 'react'
import { useRouter } from 'next/router'
import { MinimalistButton } from '@g4g/ui/src/internal/buttons/MinimalistButton'
import PlaceholderKorag from '@g4g/ui/src/internal/PlaceholderKorag'

const RecipientError: FC<{ message: string }> = ({ message }) => {
  const router = useRouter()

  return (
    <PlaceholderKorag
      callToAction={
        <MinimalistButton
          data-cy="shop-reload-page-btn"
          props={{
            mainColor: 'white',
            buttonText: 'Try Again',
            onClick: () => router.reload(),
          }}
        />
      }
    >
      <span className="px-4 text-rose-500">{message}</span>
    </PlaceholderKorag>
  )
}

export default RecipientError
